import * as React from 'react';
import type { ItemPatchRequest } from '@/lib/api/types/items';

export type CommitCellMutation = (
  itemId: number,
  data: ItemPatchRequest,
  callbacks: { onSuccess: () => void; onError: () => void },
) => void;

type TableCellMutationContextValue = {
  commit: CommitCellMutation;
};

export const TableCellMutationContext = React.createContext<
  TableCellMutationContextValue | undefined
>(undefined);

export const TableCellMutationProvider = ({
  commitCellMutation,
  children,
}: {
  commitCellMutation?: CommitCellMutation;
  children: React.ReactNode;
}) => {
  const value = React.useMemo(
    () => (commitCellMutation ? { commit: commitCellMutation } : undefined),
    [commitCellMutation],
  );
  return (
    <TableCellMutationContext.Provider value={value}>{children}</TableCellMutationContext.Provider>
  );
};
